import { SIDEBAR_IS_HIDDEN } from './types';

export function sidebarIsHidden() {
  return {
    type: SIDEBAR_IS_HIDDEN
  };
}
